<template>
   <v-dialog v-model="show" max-width="500">
    <v-card>
         <v-toolbar
          dark
          color="primary"
        >
        <v-spacer></v-spacer> 
          <v-toolbar-title>Ohodnotenie upratovača</v-toolbar-title>
          <v-spacer></v-spacer> 
           <v-btn
            class=""
            icon
            dark
            @click.stop="show=false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>   
        </v-toolbar>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <h2>{{ order.choosePerson.name }} {{ order.choosePerson.surname }}</h2>
            </v-col>
            <v-rating
            v-model="stars"
            empty-icon="mdi-star-outline"
            full-icon="mdi-star"
            half-increments
            hover
            length="5"
            size="30"
            ></v-rating>
           
          </v-row>
          <v-row>
                <v-textarea
                v-model="feedbackNote"
                solo
                label="Slovné hodnotenie upratovača"
                placeholder='Tu môžeš napísať slovné hodnotenie upratovača'
                ></v-textarea>
            </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="saveFeedback">
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>


<script>
import * as axios from "axios";
import store from "@/store/store";

export default {
    name: "LeaveFeedback",
    props: ["order", "value"],
    computed: {
        show: {
            get () {
                return this.value
            },
            set(value) {    
                this.$emit('input', value)
            }
        }
    },
    data: () => ({
        stars: 0,
        feedbackNote: "",
  }),
   methods: {
       saveFeedback() {
         
          
          let orders = localStorage.getItem("orders")
          orders = JSON.parse(orders)
          let jsonOrder = orders[this.order.code]
          orders[this.order.code] = {...jsonOrder}
          localStorage.setItem("orders", JSON.stringify(orders))
         const params = new URLSearchParams()
         params.append("rating", this.stars)
         params.append("note", this.feedbackNote)
         params.append("cleaner", this.order.cleanerId)
         params.append("code", this.order.code)
         axios({
           method: "post",
           url: store.state.url.concat("sendRating.php"),
           data: params,
         }).then(
             response => {
               if (response.data.result == 'ok'){
                 this.$emit('setfeedback', {stars: this.stars, feedbackNote: this.feedbackNote})
                  this.show = false
               }
             },
             error => {
               console.log(error);
             }
         )
      }
   },
}


</script>